import { ProfitOrCost } from '@modules/accounting-and-finance/interface/profit-and-cost/profit-and-cost-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ProfitOrCost[] = [];

export const ACCGProfitAndCostListSlice = createSlice({
  name: 'accgProfitAndCostList',
  initialState,
  reducers: {
    setACCGProfitAndCostList: (
      _state,
      action: PayloadAction<ProfitOrCost[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGProfitAndCostList: () => {
      return initialState;
    },
  },
});

export default ACCGProfitAndCostListSlice.reducer;

export const { setACCGProfitAndCostList, removeACCGProfitAndCostList } =
  ACCGProfitAndCostListSlice.actions;
